export default __webpack_public_path__ + "static/media/searchIcon_img.3cc7ac40.png";